export const LOAD_TAX_PARAMETERS = 'load_tax_parameters';
export const TAX_PARAMETERS_LOADED = 'set_loaded_tax_parameters';
export const SAVE_TAX_PARAMETER = 'save_tax_parameter';
export const TAX_PARAMETER_SAVED = 'tax_parameter_saved';
export const TAX_PARAMETER_DELETED = 'tax_parameter_deleted';
export const RESET_TAX_PARAMETERS = 'reset_tax_parameters';
export const RESET_SEARCH_TAX_PARAMETERS = 'reset_search_tax_parameters';
export const SYNC_FAILED = 'tax_parameters_sync_error';
